export default "__VITE_ASSET__d0b6c5f6__"